//
//
//
//
//
//
//
//
//

import { getaddlog } from '@/api/hgfw'
export default {
  data () {
    return {
    }
  },
  mounted () {
    this.addLog()
  },
  methods: {
    // 浏览量
    addLog () {
      getaddlog({
        accountid: this.accountid,
        moduleid: 1200,
        submoduleid: 120119
      })
    }
  }
}
